import { Tag } from '@cian/components';
import * as React from 'react';

import { ESaleType } from '../../../../json_query';
import { ISaleTypesTag } from '../../../state/tags/definitions/sale_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ISaleTypesTagItemProps {
  tag: ISaleTypesTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const SaleTypeMap = {
  [ESaleType.F3]: '214-Ф3',
  [ESaleType.GSKContract]: 'Договор ЖСК',
  [ESaleType.Reassignment]: 'Переуступка',
  [ESaleType.PreliminaryContract]: 'Предварительный договор купли-продажи',
  [ESaleType.InvestmentContract]: 'Договор инвестирования',
  [ESaleType.Free]: 'Свободная',
  [ESaleType.Alternative]: 'Альтернатива',
};

export const SaleTypesTagItem = ({ tag, onDeleteClick, withNewTag }: ISaleTypesTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === ESaleType.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {SaleTypeMap[tag.value]}
    </TagComponent>
  );
};
